import { ListItem, Paper, Stack, Box, Typography, Grid } from "@mui/material";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
// import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import RowTextField from "../ChecklistTemplates/RowTextField";
// import RowTypeSelect from "../ChecklistTemplates/RowTypeSelect";
// import RowOptionsSelect from "../ChecklistTemplates/RowOptionsSelect";
import YesNoControl from "./YesNoControl";
import FileControl from "./FileControl";
import SelectControl from "./SelectControl";
import MultiSelectControl from "./MultiSelectControl";
import TextFieldControl from "./TextFieldControl";
import SignatureControl from "./SignatureControl";

export default function ChecklistRowCard(props) {
  return (
    <div>
      {props.rows.map((obs, idx) => (
        <ListItem key={idx} style={{ padding: 0 }}>
          <Paper
            elevation={6}
            style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
          >
            <div style={{ padding: 20 }}>
              <Stack>
                {obs["Row Type"] === "Header" ||
                obs["Row Type"] === "Information Row" ? (
                  <Box
                    sx={{
                      width: "100%",
                      height:
                        (obs["Row Type"] === "Header") |
                        (obs["Row Type"] === "Information Row")
                          ? 10
                          : 10,
                      borderRadius: 1,
                      bgcolor: obs.Selected
                        ? "primary.main"
                        : obs["Row Type"] === "Header"
                        ? "primary.main"
                        : obs["Row Type"] === "Information Row"
                        ? "primary.light"
                        : "primary.light",
                      // "&:hover": {
                      //   bgcolor: "primary.dark",
                      // },
                    }}
                  />
                ) : null}

                <Grid style={{ paddingTop: 20 }} container spacing={2}>
                  <Grid size={{ xs: 4, sm: 1 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      {/* <Typography
                        variant="subtitle1"
                        color="primary.light"
                      >{`Row No:`}</Typography> */}
                      <Typography
                        color="primary.light"
                        style={{ marginLeft: 6 }}
                      >{`${obs.No}.)`}</Typography>
                    </Stack>
                  </Grid>
                  <Grid
                    display={{ xs: "block", md: "none" }}
                    size={{ xs: 12, sm: 8 }}
                  >
                    <Typography
                      variant={
                        obs["Row Type"] === "Header" ||
                        obs["Row Type"] === "Information Row"
                          ? "h6"
                          : "subtitle1"
                      }
                      color="primary.light"
                    >
                      {obs["Row Text"]}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 3 }}>
                    {obs["Row Type"] === "Yes/No" ? (
                      <YesNoControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        showNa={false}
                      />
                    ) : obs["Row Type"] === "Yes/No/NA" ? (
                      <YesNoControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        showNa={true}
                      />
                    ) : obs["Row Type"] === "File" ? (
                      <FileControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        showNa={true}
                      />
                    ) : obs["Row Type"] === "Single Select" ? (
                      <SelectControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        options={obs["Select Options"]}
                      />
                    ) : obs["Row Type"] === "Multiple Select" ? (
                      <MultiSelectControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        options={obs["Select Options"]}
                      />
                    ) : obs["Row Type"] === "Text" ? (
                      <TextFieldControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                      />
                    ) : obs["Row Type"] === "Signature" ? (
                      <SignatureControl
                        id={obs.id}
                        onChange={props.onChange}
                        value={obs.value}
                        importTitle={obs["Row Text"]}
                        onClearSignature={props.onClearSignature}
                      />
                    ) : null}
                  </Grid>
                  <Grid
                    display={{ md: "block", xs: "none" }}
                    size={{ xs: 12, sm: 8 }}
                  >
                    <Typography
                      variant={
                        obs["Row Type"] === "Header" ||
                        obs["Row Type"] === "Information Row"
                          ? "h6"
                          : "subtitle1"
                      }
                      color="primary.light"
                    >
                      {obs["Row Text"]}
                    </Typography>
                  </Grid>
                </Grid>
                {/*   <Grid size={{ xs: 12, sm: 4 }}>
                   <Stack
                      style={{ paddingTop: 6 }}
                      direction="row"
                      spacing={1}
                      sx={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title="Move Down">
                        <IconButton
                          aria-label="Move Down"
                          disabled={idx + 1 === props.rows.length}
                          size="large"
                          onClick={() =>
                            props.onMove({ id: obs.id, direction: "Down" })
                          }
                          color={obs.Selected ? "primary" : "secondary.light"}
                        >
                          <ArrowDownwardIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Move Up">
                        <IconButton
                          aria-label="Move Up"
                          size="large"
                          disabled={idx === 0}
                          onClick={() =>
                            props.onMove({ id: obs.id, direction: "Up" })
                          }
                          color={obs.Selected ? "primary" : "secondary.light"}
                        >
                          <ArrowUpwardIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete Row">
                        <IconButton
                          aria-label="Delete Row"
                          size="large"
                          onClick={() => props.onDeleteRow(obs.id)}
                          color={obs.Selected ? "primary" : "secondary.light"}
                        >
                          <DeleteForeverIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                  
                  </Grid> */}
              </Stack>
            </div>
          </Paper>
        </ListItem>
      ))}
    </div>
  );
}
